import React from 'react';
import clsx from 'clsx';

const Card = ({ className, style, children, ...props }) => (
  <div className={clsx('vs-card', className)} style={style} {...props}>
    {children}
  </div>
);

export default Card;


